import moment from 'moment'
import {ActionTypes, FILTERINFO} from './filterActions'
import {filterInitialState} from './filterInitialState'

export const actions = {
  updateFilterInfo: (data: FILTERINFO) => ({type: 'UPDATEFILTERINFO', payload: data}),
  cleanFilterInfo: (filterName: string) => ({type: 'CLEANFILTERINFO', payload: filterName}),
  updateApplyFilterStatus: (data: boolean) => ({type: 'UPDATEAPPLYFILTERSTATUS', payload: data}),
}

export const filterReducer = (state = filterInitialState, action: ActionTypes) => {
  switch (action.type) {
    case 'UPDATEFILTERINFO':
      const {filterForm, value, field} = action.payload
      const updateFilterState = JSON.parse(JSON.stringify(state))
      updateFilterState[filterForm][field] = value
      return updateFilterState
    case 'CLEANFILTERINFO':
      const cleanFilterState = JSON.parse(JSON.stringify(state))
      if (action.payload && cleanFilterState[action.payload]) {
        for (let element in cleanFilterState[action.payload]) {
          if (element == 'fromDate') {
            if (action.payload == 'FilterRenew') {
              cleanFilterState[action.payload][element] = moment()
                .subtract(4, 'months')
                .startOf('month')
                .format('YYYY/MM/DD')
            } else if (action.payload == 'FilterPersonInsurance') {
              cleanFilterState[action.payload][element] = moment()
                .subtract(12, 'months')
                .startOf('month')
                .format('YYYY/MM/DD')
            } else
              cleanFilterState[action.payload][element] = moment()
                .subtract(1, 'months')
                .startOf('month')
                .format('YYYY/MM/DD')
          } else if (element == 'toDate') {
            if (action.payload == 'FilterRenew') {
              cleanFilterState[action.payload][element] = moment()
                .add(3, 'years')
                .endOf('month')
                .format('YYYY/MM/DD')
            } 
             else if (action.payload == 'FilterPersonInsurance') {
              cleanFilterState[action.payload][element] = moment()
                .add(12, 'months')
                .startOf('month')
                .format('YYYY/MM/DD')
            }else
              cleanFilterState[action.payload][element] = moment()
                .endOf('month')
                .format('YYYY/MM/DD')
          } else cleanFilterState[action.payload][element] = null
        }
      }
      return cleanFilterState
    case 'UPDATEAPPLYFILTERSTATUS':
      const updateApplyFilterState = JSON.parse(JSON.stringify(state))
      updateApplyFilterState.applyFilter = action.payload
      return updateApplyFilterState
    default:
      return state
  }
}

export function* saga() {}
